<template>
    <div class="sidebar">
        <el-menu
            class="sidebar-el-menu"
            :default-active="onRoutes"
            :collapse="getCollapse"
            background-color="#333333"
            text-color="rgba(255,255, 255, 0.6)"
            active-text-color="#ffffff"
            unique-opened
            router
        >
            <template v-if="getUser.userType == '2'">
                <el-menu-item :index="'businessHome'" :key="'businessHome'" class="home-menu-item">
                    <div class="nav-no-subs">
                        <img :src="getIconSvg('icon-menu1')" class="menu-icon-cls" width="100%" />
                        <span class="nav-title" slot="title">{{ $t('home000') }}</span>
                    </div>
                </el-menu-item>
            </template>
            <template v-for="item in getCurrentMenu">
                <template v-if="item.childMenuList && item.childMenuList.length > 0">
                    <el-submenu :index="item.href" :key="item.href">
                        <template slot="title">
                            <div class="top-nav" @click="goTo(item.href)">
                                <img :src="getIconSvg(item.icon)" class="menu-icon-cls" width="100%" />
                                <span class="nav-title" slot="title">{{ $t(item.menuCode) }}</span>
                            </div>
                        </template>
                        <template v-for="subItem in item.childMenuList">
                            <el-submenu
                                v-if="subItem.childMenuList && subItem.childMenuList.length > 0"
                                :index="subItem.index"
                                :key="subItem.index"
                            >
                                <template slot="title">{{ $t(subItem.menuCode) }}</template>
                                <el-menu-item v-for="(threeItem, i) in subItem.childMenuList" :key="i" :index="threeItem.href">
                                    {{ $t(subItem.menuCode) }}
                                </el-menu-item>
                            </el-submenu>
                            <el-menu-item
                                :title="$t(subItem.menuCode)"
                                v-else-if="isMenuShow(subItem)"
                                :index="subItem.href"
                                :key="subItem.href"
                            >
                                {{ $t(subItem.menuCode) }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.href" :key="item.href" class="home-menu-item">
                        <div class="nav-no-subs">
                            <img :src="getIconSvg(item.icon)" class="menu-icon-cls" width="100%" />
                            <span class="nav-title" slot="title">{{ $t(item.menuCode) }}</span>
                        </div>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
import bus from '@/components/common/bus'
import { mapGetters } from 'vuex'
import API from '@/api'

export default {
    data() {
        return {
            isComponentMember: false
        }
    },
    computed: {
        ...mapGetters('common', {
            getUser: 'getUser',
            getCollapse: 'getCollapse',
            getSite: 'getSite',
            getCurrentMenu: 'getCurrentMenu',
            getShowMenuCodeList: 'getShowMenuCodeList'
        }),
        onRoutes() {
            return this.$route.path.replace('/', '')
        }
    },
    mounted() {
        if (!this.getUser.isSecurityAuditor && this.getSite.siteId) {
            this.getIfComponentMember()
            bus.$on('updateSidebar', (val) => {
                this.isComponentMember = val
            })
        }
    },
    methods: {
        getIconSvg(icon) {
            return require(`@/assets/img/${icon}.svg`)
        },
        isMenuShow(subItem) {
            let showMenuCodeListWithSystem = [
                ...this.getShowMenuCodeList,
                ...this.getCurrentMenu.reduce((pre, cur) => {
                    if (['site000', 'system000'].includes(cur.menuCode) && cur.childMenuList) {
                        pre = [...pre, ...cur.childMenuList.map((v) => v.menuCode)]
                    }
                    return pre
                }, [])
            ]

            if (!showMenuCodeListWithSystem.includes('client007')) {
                //集团审计模块隐藏，组成部分菜单隐藏
                return (
                    subItem.menuCode !== 'site008' &&
                    subItem.menuCode !== 'site009' &&
                    showMenuCodeListWithSystem.indexOf(subItem.menuCode) !== -1
                )
            } else {
                // 限制kp人员的客户主界面（如果是组成部分人员只显示集团审计页面 && general此时joint working页面选择展现）和Client端客户主界面（confirmation受general按钮控制）
                return (
                    (this.getUser.userType === '1' &&
                        !(
                            subItem.parentCode == 'client000' &&
                            ((this.getSite.siteId && this.isComponentMember && subItem.menuCode != 'client007') ||
                                this.getShowMenuCodeList.indexOf(subItem.menuCode) === -1)
                        )) ||
                    (this.getUser.userType === '2' && this.getShowMenuCodeList.indexOf(subItem.menuCode) !== -1)
                )
            }
        },
        async getIfComponentMember() {
            let params = {
                siteId: this.getSite.siteId,
                userId: this.getUser.userId
            }
            let { code, data } = await API.exchange.queryIfKpMember(params)
            if (code == '1') {
                this.isComponentMember = data.ifKpMember
                localStorage.setItem('isComponentMember', data.ifKpMember)
            }
        },
        goTo(path) {
            this.$router.push({ path: '/' + path })
        }
    }
}
</script>

<style scoped>
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 70px;
    bottom: 0px;
    width: 84px;
}

.sidebar::-webkit-scrollbar {
    width: 0;
}

.sidebar-el-menu {
    width: 85px;
}

.sidebar-el-menu:not(.el-menu--collapse) {
    width: 255px;
}

.sidebar > ul {
    height: 100%;
}

.el-tooltip {
    padding: 0 19px !important;
}

.top-nav {
    padding: 0 22px;
    height: 100%;
}

.top-nav .menu-icon-cls {
    width: 27px;
    height: 100%;
    vertical-align: middle;
}

.nav-title {
    padding-left: 12px;
}

.home-menu-item {
    padding: 0 22px !important;
}
.nav-no-subs {
    height: 100%;
}

.nav-no-subs .menu-icon-cls {
    width: 27px;
    height: 100%;
    vertical-align: middle;
}
</style>
